var ProgressBar = require("components/utility/ProgressBar");

require("writing/answers/answer_length_meter.scss")

var AnswerLengthMeter = function(props) {

	if (props.filterCount) {
		var colorThreshold = [props.filterCount, props.charCount * 0.7]
	} else {
		var colorThreshold = [props.charCount * 0.3, props.charCount * 0.7] 
	}
	var messages = [
		"Not yet, keep on going!",
		"Almost there, keep up the good work!",
		"Your answer is long enough. When you are done, check your grammar and make sure you answer the question well!"
	]
	return (
		<div className="answerLengthMeter">
			<div className="progressionDisplay">
				<div className="title">
					Have you written enough?
				</div>
				<ProgressBar current={ props.currentCharCount }
					total={ props.charCount } dynamicColor
					colorThreshold={ colorThreshold } messages={ messages } />
			</div>
		</div>
	)
}

AnswerLengthMeter.propTypes = StrictPropTypes({
	charCount: PropTypes.number.isRequired,
	currentCharCount: PropTypes.number.isRequired,
	filterCount: PropTypes.number
});

module.exports = AnswerLengthMeter;



// WEBPACK FOOTER //
// ./modules/components/writing/answers/AnswerLengthMeter.js